import { TokenRenewMode } from '@axa-fr/react-oidc'
import { env } from 'utils/env'

export const root = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`
const AUTH = {
  CALLBACK: '/authentication/callback',
  SILENT_CALLBACK: '/authentication/silent_callback'
}
const disableServiceWorker = JSON.parse(env.REACT_APP_DISABLE_SERVICE_WORKER) || false
const maxAge = env.REACT_APP_IDENTITY_MAX_AGE
const prompt = env.REACT_APP_IDENTITY_PROMPT

const getAuthenticationConfiguration = () => {
  let config = {
    client_id: env.REACT_APP_IDENTITY_CLIENT_ID,
    authority: env.REACT_APP_IDENTITY_AUTHORITY,
    redirect_uri: `${root}${AUTH.CALLBACK}`,
    silent_redirect_uri: `${root}${AUTH.SILENT_CALLBACK}`,
    scope: 'openid profile offline_access ' + env.REACT_APP_IDENTITY_SCOPE,
    refresh_time_before_tokens_expiration_in_second: 40,
    token_renew_mode: TokenRenewMode.access_token_invalid
  }

  if (prompt) {
    config.prompt = prompt
  }
  if (maxAge) {
    config.max_age = parseInt(maxAge, 10)
  }

  if (disableServiceWorker) {
    config.service_worker_only = false
  } else {
    config.service_worker_relative_url = '/OidcServiceWorker.js'
  }

  if (window.location.pathname === env.REACT_APP_IDENTITY_TESTUSERS_TRIGGER_QUERYSTRING) {
    config.extras = {
      acr_values: 'idp:local'
    }
  }

  return config
}

export default getAuthenticationConfiguration
